import { render } from "./CadastroFormasPagamentoView.vue?vue&type=template&id=f551458e"
import script from "./CadastroFormasPagamentoView.vue?vue&type=script&lang=js"
export * from "./CadastroFormasPagamentoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__